import { useNavigate } from 'react-router-dom';

import { getFirstAccessibleRoute } from '../components/layout/nav-config.js';
import { useAuth } from '../hooks/useAuth.js';
import { getLastForbidden } from '../lib/forbiddenState.js';

// Se muestra cuando el backend rechaza una petición con 403 real (ver
// handleForbidden en lib/api.ts) — cuenta desactivada a media sesión, o
// cualquier acción sin permiso (ej. PATCH /tickets/:id/responsables con un
// rol no autorizado). Distinto de RequireRol: aquel es para navegación
// normal con sesión válida pero sin permiso de RUTA; esto es para cuando el
// backend rechazó una ACCIÓN/PETICIÓN puntual.
export function SinAccesoPage() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const info = getLastForbidden();

  const esCuentaInactiva = info?.code === 'CUENTA_INACTIVA';
  const titulo = esCuentaInactiva ? 'Cuenta suspendida' : 'Acceso denegado';
  // El mensaje siempre es el que mandó el backend — nunca uno inventado.
  const mensaje = info?.message ?? 'No tienes permiso para realizar esta acción.';

  function volverAlInicio() {
    navigate(getFirstAccessibleRoute(user?.rol), { replace: true });
  }

  return (
    <div className="login-screen">
      <div className="login-box" style={{ textAlign: 'center' }}>
        <div className="login-logo" style={{ justifyContent: 'center' }}>
          <div className="login-logo-mark">NX</div>
          <div className="login-logo-text">
            Nexus
            <span>Leadsphere Connect</span>
          </div>
        </div>

        <div style={{ fontSize: 40, lineHeight: 1, margin: '4px 0 12px' }}>{esCuentaInactiva ? '🚫' : '⛔'}</div>
        <h2 style={{ fontSize: 17, fontWeight: 700, color: 'var(--heading)', margin: '0 0 8px' }}>{titulo}</h2>
        <p style={{ fontSize: 13, color: 'var(--muted)', marginBottom: 24 }}>{mensaje}</p>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          {user && (
            <button className="google-btn" onClick={volverAlInicio}>
              Volver al inicio
            </button>
          )}
          <button className="google-btn" onClick={logout}>
            Cerrar sesión
          </button>
        </div>
      </div>
    </div>
  );
}
